<!-- 销售退货列表 -->
<template>
  <div class='page_content'>
    <el-drawer :close-on-press-escape="true" :visible.sync="showStatus" :with-header="false" append-to-bodycustom-class="drawer_box" direction="ltr" size="100%">
      <oneStepsalesInitiaReturnAction v-if="showStatus" ref="oneStepsalesInitiaReturnAction" @drawerCancel="drawerCancel" @toDetail="toDetail" :actionData="actionData"></oneStepsalesInitiaReturnAction>
    </el-drawer>
    <div class="page_content_top">
      <v-button :buttonList="buttonList" @actionSet="actionSet" @getPageInfo="getPageInfo" @openFormDesign="openFormDesign"></v-button>
      <div class="page_content_top_line">
        <v-search v-if="pageShowData.jurHead" :searchList="pageShowData.jurHead.jurconfigform" :getRequestData="getRequestData" @searchData="searchData" @openSearch="openSearch"></v-search>
      </div>
    </div>
    <div class="page_content_center">
      <el-table v-if="pageShowData.jurTableVo" stripe :data="returnData.list" :height="tableHeight" :key="$store.state.tableNum" border style="width: 100%" @selection-change="handleSelectionChange" highlight-current-row size="mini">
        <el-table-column type="selection" width="40">
        </el-table-column>
        <!-- 主表 -->
        <el-table-column align="center" v-if="tableValye.isShow==1" v-for="(tableValye,tableKey) in pageShowData.jurTableVo.jurconfigtable" :key="tableKey" show-overflow-tooltip :min-width="tableValye.fieldWeight"
          :prop="tableValye.entityField" :label="tableValye.showField">
          <template slot-scope="scope">
            <span v-if="tableValye.fieldType == 'date'">
              <span v-if="scope.row[tableValye.entityField]">
                {{$common.getLocalTime(scope.row[tableValye.entityField])}}
              </span>
            </span>
            <!-- 状态判断 -->
            <el-tag size="mini" v-else-if="tableValye.entityField == 'rgamState'">
              {{$common.getIsGsp(tableValye.formatterContent,scope.row.rgamState)}}</el-tag>
            <span v-else-if="tableValye.isRift == 1">
              <a @click="toDetail(scope.row[tableValye.riftField])">{{scope.row[tableValye.entityField]}}</a>
            </span>
            <span v-else>
              {{scope.row[tableValye.entityField]}}
            </span>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="page_content_bottom">
      <v-pagination :page="getRequestData.page" :rows="getRequestData.rows" :total="returnData.total" @setDataPageSize="setDataPageSize" @setDataPageNumber="setDataPageNumber"></v-pagination>
    </div>
    <el-dialog :title="seTitle" v-if="DialogVisible" :visible.sync="DialogVisible" :width="seWidth">
      <SearchScheme ref="searchScheme" :id="seId" :smId="cmId" :parentSearchData="parentSearchData" @TranData="changeInputModel" @getWidth="getSeWidth" @sendTitle="getSearchName" />
    </el-dialog>
    <printPlan ref="printPlan"></printPlan>
    <!-- 自定义设计 -->
    <customDesign ref="customDesign"></customDesign>
  </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import SearchScheme from '@/byComponents/SearchScheme.vue'
import oneStepsalesInitiaReturnAction from "@/components/oneStepsalesInitiaReturnAction.vue";
export default {
  //import引入的组件需要注入到对象中才能使用
  components: { SearchScheme,oneStepsalesInitiaReturnAction },
  data() {
    //这里存放数据
    return {
      tableHeight: 0,
      getRequestData: {
        // rgamRapcus:'',
        cmName: '',
        page: 1,
        rows: 30,
        start: new Date(new Date().toLocaleDateString()).getTime() - 31 * 24 * 3600 * 1000,	//开始上一个月
        end: new Date(new Date().toLocaleDateString()).getTime() + 24 * 60 * 60 * 1000 - 1,	//当天最后时间
        "creater": '',
        "ormId": '',
        "smId": '',
      },
      returnData: {
        pages: 0,  // 总页数
        total: 0,  // 总条数
        pageNum: 0,  // 当前页数
        list: []
      },
      buttonList: [],

      pageShowData: [],
      formDataList: [],
      seTitle: "",//检索
      DialogVisible: false,
      seWidth: '0',
      seId: 0,
      cmId: '',
      showStatus: false,
      actionData: {},
      parentSearchData: {},
      sField: '',
      multipleSelection: [],
    }
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {
  },
  //方法集合
  methods: {
    handleSelectionChange(val) {
      this.multipleSelection = val;
      console.log(this.multipleSelection);
    },
    // 子组件触发
    drawerCancel() {
      this.showStatus = false
      this.getDataList()
    },
    // 点击穿透字段 传参单号
    toDetail(orderId) {
      if (orderId) {
        // 设置为true 打开穿透组件首页    
        var isPenetrate = true
        // 设置缓存 存入点击单号
        this.resetSetItem('penetrateOrderId', orderId);
        // 与父级跨域通信 传递isPenetrate参数
        window.parent.postMessage({  //向窗口发送MessageEvent消息
          cmd: 'returnFormJson',
          params: { isPenetrate } //参数
        }, '*');
      }
    },
    // 检索Id, 索引(表格中), 标识
    openSearch({ sId, index, type, sField }) {
      this.DialogVisible = true
      this.seId = sId
      this.sField = sField
      this.parentSearchData[type] = this.getRequestData[type]
    },
    //检索带回数据
    changeInputModel(val) {
      if (val != "" || val != undefined) {
        this.DialogVisible = false;
        if (val.cmId) {//销售单位
          this.cmId = val.cmId
          this.paramValue(val)
        }
      }
    },
    // 赋值字段
    paramValue(val) {
      let arr = this.sField.split(',')
      arr.forEach(item => {
        this.getRequestData[item] = val[item]
      })
    },
    getSeWidth(e) {
      this.seWidth = e + "%";
    },
    getWidth(e) {
      this.exWidth = e + "%";
    },
    getSearchName(e) {
      this.seTitle = e;
    },

    isShowData(name, value) {
      switch (name) {
        case 'customerList':
          var dataInfo = sessionStorage.getItem('selectCustomerData')
          if (dataInfo) {
            dataInfo = JSON.parse(dataInfo)
            this.getRequestData.rgamRapcus = dataInfo.cmId
            this.getRequestData.cmName = dataInfo.cmName
          }

          break;

        default:
          this.getRequestData[name] = value

      }
    },



    // 获取数据列表
    async getPageInfo() {
      var pathId = parent.getMenuInfo(this.$route.path)
      let responseData = await this.$http.getJur({ ids: [pathId.jurId] })
      if (responseData.status == 200) {
        this.getButtonList()
        this.pageShowData = responseData.result
        this.formDataList = this.pageShowData.jurFormVoList
        var obj = {}
        if (this.pageShowData.jurHead) {
          obj = this.$common.getSearchData(this.pageShowData.jurHead.jurconfigform, 'page', "rows", 30)
        } else {
          obj = this.$common.getSearch(this.getRequestData, 'start', 'end', 'page', 'rows', 30)
        }
        for (const key in obj) {
          this.$set(this.getRequestData, key, obj[key])
        }
        this.getDataList()
      } else {
        this.$message({
          message: responseData.message,
          type: 'error'
        });
      }
    },
    // 动作集合
    actionSet(actionData) {
      switch (actionData.actionType) {
        case 0:
          this.showStatus = true
          this.actionData = {
            cate: 0, formData: this.formDataList,
            oldData: '', orderId: '', printSouce: '',
            printJurId: ''
          }
          break;
        case 1:
          if (this.returnData.list.length <= 0) {
            this.$message({
              message: '暂无数据',
              type: 'error'
            });
            return false
          }
          if (this.multipleSelection.length != 1) {
            this.$message({
              message: "请先选中一条操作数据",
              type: "error",
            });
            return false;
          }
          this.showStatus = true;
          this.actionData = {
            cate: 1,
            formData: this.formDataList,
            oldData: this.multipleSelection[0],
            orderId: this.multipleSelection[0].rgamId, printSouce: '',
            printJurId: ''
          }
          break;
        case 2:
          this.delDataAction()
          break;
        case 3:
          this.submitData()
          break;
        case 8:
          this.showPrintPlan()
          break;
      }
    },
    openFormDesign() {
      let pathInfo = parent.getMenuInfo(this.$route.path)
      this.$refs['customDesign'].openBox(pathInfo.jurId, this.pageShowData, pathInfo.jurName)
    },
    showPrintPlan() {
      if (this.multipleSelection.length != 1) {
        this.$message({
          message: "请先选中一条操作数据",
          type: "error",
        });
        return false;
      }
      // 调用全局方法 判断Websocket是否连接
      if (this.$printSocketApi.printExeMsg() != false) {
        // 选中的数据
        var info = this.multipleSelection[0];
        this.$refs.printPlan.openDia(info.rgamId);
      } else {
        return;
      }
    },
    // 数据搜索
    searchData() {
      this.getRequestData.page = 1
      this.getDataList()
    },
    // 数据翻页
    setDataPageNumber(val) {
      this.getRequestData.page = val
      this.getDataList()
    },
    // 切换显示条数
    setDataPageSize(val) {
      this.getRequestData.page = 1
      this.getRequestData.rows = val
      this.getDataList()
    },
    // 获取数据列表
    async getDataList() {
      let responseData = await this.$http.rgbkAccountQuery(this.getRequestData)
      if (responseData.status == 200) {
        this.returnData.list = responseData.result.list
        this.returnData.pages = responseData.result.pages
        this.returnData.total = responseData.result.total
        this.returnData.pageNum = responseData.result.pageNum
      } else {
        this.$message({
          message: responseData.message,
          type: 'error'
        });
      }
    },

    // 删除数据
    delDataAction() {

      if (this.returnData.list.length <= 0) {
        this.$message({
          message: '暂无数据',
          type: 'error'
        });
        return false
      }
      if (this.multipleSelection.length != 1) {
        this.$message({
          message: "请先选中一条操作数据",
          type: "error",
        });
        return false;
      }
      this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        var delData = {
          ids: [this.multipleSelection[0].rgamId]
        }
        let responseData = await this.$http.delSalesReturn(delData)
        if (responseData.status == 200) {
          this.$message({
            type: 'success',
            message: '删除成功!'
          });

          this.getDataList()
        } else {
          this.$message({
            message: responseData.message,
            type: 'error'
          });
        }

      }).catch(() => { });

    },
    // 提交审核
    submitData() {
      if (this.returnData.list.length <= 0) {
        this.$message({
          message: '暂无数据',
          type: 'error'
        });
        return false
      }
      var dataInfo = []
      if (this.multipleSelection.length == 0) {
        this.$message({
          message: "请先选中要操作数据",
          type: "error",
        });
        return false;
      }
      this.multipleSelection.forEach(item => {
        dataInfo.push(item.rgamId)
      })
      this.$confirm('确定要提交审核吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        var delData = {
          ids: dataInfo
        }
        let responseData = await this.$http.submitSalesReturn(delData)
        if (responseData.status == 200) {
          this.$message({
            type: 'success',
            message: '操作成功!'
          });

          this.getDataList()
        } else {
          this.$message({
            message: responseData.message,
            type: 'error'
          });
        }

      }).catch(() => { });

    },
    // 获取按钮权限
    async getButtonList() {
      this.buttonList = await this.$common.getActionButton()
      
    },
//获取状态
    getIsGsp(str, val) {
      try {
        str && str.replace(/\\/g, '')
        let arr = JSON.parse(str)
        let len = arr.length
        let newStr = ''
        for (let i = 0; i < len; i++) {
          if (arr[i].key == val) {
            newStr = arr[i].value
            break;
          }
        }
        return newStr
      } catch (ex) {
        return str
      }
    },


  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {
    this.getPageInfo()
  },
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {

  },
  beforeCreate() { }, //生命周期 - 创建之前
  beforeMount() { }, //生命周期 - 挂载之前
  beforeUpdate() { }, //生命周期 - 更新之前
  updated() { this.tableHeight = this.$common.getTableHeight() }, //生命周期 - 更新之后
  beforeDestroy() { }, //生命周期 - 销毁之前
  destroyed() { }, //生命周期 - 销毁完成
  activated() { }, //如果页面有keep-alive缓存功能，这个函数会触发
}
</script>
<style scoped>
.table_content_tag {
  margin-right: 1rem;
}

.el-tabs--border-card_new {
  height: 85vh;
  overflow-y: scroll;
}
</style>